export default __webpack_public_path__ + "static/media/avoid-damage-to-reputation.3172b45c.svg";